export default "__VITE_ASSET__DdPrQG$V__"